import { ReduxData } from '../../global/types'

export const TRIGGER_REQUEST = 'REQUEST/TRIGGER_REQUEST'
export const TRIGGER_REQUEST_SUCCESS = 'REQUEST/TRIGGER_REQUEST_SUCCESS'
export const TRIGGER_REQUEST_ERROR = 'REQUEST/TRIGGER_REQUEST_ERROR'

// actions types
export type TriggerRequestAction = {
  type: typeof TRIGGER_REQUEST
  id: string
  url: string
  method: string
  data: ReduxData | Record<string, unknown>
  normalizer: string
}

export type TriggerRequestSuccessAction = {
  type: typeof TRIGGER_REQUEST_SUCCESS
  id: string
}

export type TriggerRequestErrorAction = {
  type: typeof TRIGGER_REQUEST_ERROR
  id: string
  error: string
}

export type TriggerRequestProps = {
  id: string
  url: string
  method: string
  data: ReduxData | Record<string, unknown>
  normalizer: string
}

export const triggerRequest = ({
  id,
  url,
  method,
  data,
  normalizer,
}: TriggerRequestProps): TriggerRequestAction => ({
  type: TRIGGER_REQUEST,
  id,
  url,
  method,
  data,
  normalizer,
})

export const triggerRequestSuccess = (
  id: string,
): TriggerRequestSuccessAction => ({
  type: TRIGGER_REQUEST_SUCCESS,
  id,
})

export const triggerRequestError = (
  id: string,
  error: string,
): TriggerRequestErrorAction => ({
  type: TRIGGER_REQUEST_ERROR,
  id,
  error,
})
